import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicantSettings, FIELD_SETTINGS_DEFAULTS, RelationshipType } from '@common/entities';
import {
  ApplicationSettingsState,
  clearApplicationSettings,
  setApplicationSettings,
} from 'state/slices/applicationSettingsSlice';
import { RootState } from 'state/store';

const isApplicantRelationship = (
  relationshipType: RelationshipType,
): relationshipType is
  | RelationshipType.Primary
  | RelationshipType.Coapplicant
  | RelationshipType.Guarantor =>
  relationshipType === RelationshipType.Primary ||
  relationshipType === RelationshipType.Coapplicant ||
  relationshipType === RelationshipType.Guarantor;

export const useApplicationSettings = (relationshipType = RelationshipType.Primary) => {
  const dispatch = useDispatch();
  const settings = useSelector((state: RootState) => state.applicationSettings);

  const updateSettings = useCallback(
    (newSettings: ApplicationSettingsState) => {
      dispatch(setApplicationSettings(newSettings));
    },
    [dispatch],
  );

  const resetSettings = useCallback(() => {
    dispatch(clearApplicationSettings());
  }, [dispatch]);

  const applicantSettings: ApplicantSettings | undefined = isApplicantRelationship(relationshipType)
    ? settings[relationshipType]
    : undefined;

  const minAge = applicantSettings?.minAge ?? FIELD_SETTINGS_DEFAULTS.DATE_OF_BIRTH.MIN_AGE;

  return {
    settings,
    updateSettings,
    resetSettings,
    minAge,
  };
};
